import {
  getFontCss,
  HoverableLinkSizes,
  Processing,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import TestId from 'src/components/TestId/TestId'
import { useBackgroundDispatch } from 'src/hooks'
import Trns from 'src/localization/Trns'
import { SecondaryEmailResponse } from 'src/models/user.models'
import { createSetIsAddSecondaryEmailPopupOpen } from 'src/redux/actions/app.actions'
import { css } from 'styled-components'

interface SecondaryEmailLinkProps {
  className?: string
  loading: boolean
  secondaryEmails: SecondaryEmailResponse[]
  isEditing: boolean
  removeSecondaryEmail: boolean
}

const SecondaryEmailLink: React.FC<SecondaryEmailLinkProps> = (
  props,
): React.ReactElement => {
  const dispatch = useBackgroundDispatch()

  const firstEmail =
    props.secondaryEmails.length > 0 ? props.secondaryEmails[0] : undefined

  return (
    <div className={props.className}>
      {props.loading ? (
        <Processing />
      ) : firstEmail ? (
        <div
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            display: flex;
            gap: 10px;
          `}
        >
          <span
            css={css`
              ${props.removeSecondaryEmail &&
              css`
                text-decoration: line-through;
                ${getFontCss(
                  16,
                  styleConstants.colors.gray_dark,
                  styleConstants.fontFamilies.regular,
                )};
              `}
            `}
          >
            {firstEmail?.email}
          </span>
        </div>
      ) : (
        <TestId testId={'addSecondaryEmailLink'}>
          <HoverableLink
            css={css`
              display: flex;
              flex-direction: row;
            `}
            onClick={(): void => {
              dispatch(createSetIsAddSecondaryEmailPopupOpen(true))
            }}
            underline
            regular
            size={HoverableLinkSizes.Large}
            ariaLabelSource={'Add a secondary email'}
          >
            {'+ '}
            <Trns source={'Add a secondary email'} />
          </HoverableLink>
        </TestId>
      )}
    </div>
  )
}

export default SecondaryEmailLink
